module.exports = __webpack_public_path__ + "img/performance-9.66f78bea.png";